import { Component, input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-submit-button',
  templateUrl: './submit-button.component.html',
  imports: [TranslatePipe],
})
export class SubmitButtonComponent {
  readonly sending = input(false)
  readonly disabled = input(false)
  readonly labelKey = input.required<string>()
  readonly sendingLabelKey = input.required<string>()
}
